import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';
import Slider from 'react-slick';
import PictionJS from 'piction-js';
import { disableRightClick } from '../../utils/uiUtils';


function UMODetailViewRelated({ umo, alternates, onAltClick, intl }) {
  let sliderRef;
  const sliderSettings = {
    draggable: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    swipeToSlide: true,
    arrows: false,
  };
  const altItems = alternates.all.map(alt =>
    <li
      key={alt.id}
      id={alt.id}
      onClick={onAltClick}
      className={classNames(
        'umo-detail-view__image-related-images-item',
        { 'umo-detail-view__image-related-images-item--selected': umo.id === alt.id }
      )}
      style={{ display: 'flex' }}
    >
      <img
        id={alt.id}
        alt=""
        src={alt.thumbnail.url}
        width={alt.data.w[0]}
        height={alt.data.h[0]}
        onContextMenu={disableRightClick}
      />
    </li>
  );

  return (
    <div className="umo-detail-view__image-related">
      <h4 className="umo-detail-view__image-related-title">
        <FormattedMessage id="umoDetailView.relatedItemHeader" />
      </h4>
      <div className="umo-detail-view__image-related__slider">
        <div
          onClick={() => { sliderRef.slickPrev(); }}
          className={
            classNames(
              'umo-detail-view__image-related__slider-arrow',
              'umo-detail-view__image-related__slider-arrow-left'
            )}
        >
          <i className="umo-detail-view__image-related__slider-arrow-left-icon" />
        </div>
        <ul className="umo-detail-view__image-related-images">
          {
            <Slider {...sliderSettings} ref={(ref) => { sliderRef = ref; }}>
              {altItems}
            </Slider>
        }
        </ul>
        <div
          onClick={() => { sliderRef.slickNext(); }}
          className="umo-detail-view__image-related__slider-arrow umo-detail-view__image-related__slider-arrow-right"
        >
          <i className="umo-detail-view__image-related__slider-arrow-right-icon" />
        </div>
      </div>
    </div>
  );
}

UMODetailViewRelated.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO),
  alternates: PropTypes.instanceOf(PictionJS.UMOList),
  onAltClick: PropTypes.func,
};

export default injectIntl(UMODetailViewRelated);



// WEBPACK FOOTER //
// ./src/js/components/UMODetailView/UMODetailViewRelated.jsx